import { capitalize, upperCase } from 'lodash';
import { camelcaseToTitlecase } from 'helpers/string.helpers';
import type { PartialOrganisationUserWithPartialUser } from 'services/assist-api/entities/customer-user/types';
import { MarkStatus } from 'services/assist-api/entities/test-instance-response-mark/types';
import { TestInstanceResponseInputType } from 'services/assist-api/entities/test-instance-response/types';

export function markStatusDisplayName(status: MarkStatus | null): string {
  // If a status is null, we can consider it to be assigned (not created/started yet), since marks
  // are only created when they are first saved.
  if (status === null) {
    return camelcaseToTitlecase(MarkStatus.Assigned);
  }
  return camelcaseToTitlecase(status.replace('finished', 'finished:')).replace('For', 'for');
}

export function markResponseHref(responseId: number, markId: number | undefined): string {
  return `/marking/mark-response/${responseId}${markId ? `?markId=${markId}` : ''}`;
}

export function markingGroupHref(groupId: number): string {
  return `/marking/marking-groups/${groupId}`;
}

export function markerDisplayName(
  organisationUser: PartialOrganisationUserWithPartialUser | undefined
): string {
  if (
    !organisationUser?.user.firstname ||
    !organisationUser?.user.lastname ||
    !organisationUser?.user.username
  )
    return 'Error: Marker details not found.';
  return `${organisationUser?.user.firstname} ${organisationUser?.user.lastname}`;
}

export function friendlyMode(mode: TestInstanceResponseInputType): string {
  if (mode === TestInstanceResponseInputType.Ai) {
    return upperCase(TestInstanceResponseInputType.Ai);
  }

  return capitalize(mode);
}

export function modeDisplayNames(modes: TestInstanceResponseInputType[]): string {
  return modes.map((m) => friendlyMode(m)).join(', ');
}
